import { useEffect, useState } from 'react';
import { api } from '../api';
import { OBJECTS } from '../config';

interface Schedule {
  id: string;
  name: string;
  objectType: string;
  frequency: string;
  hour: number;
  nextRunAt: string | null;
}

export function ReportsPage() {
  const [schedules, setSchedules] = useState<Schedule[]>([]);
  const [name, setName] = useState('');
  const [objectType, setObjectType] = useState('deal');
  const [frequency, setFrequency] = useState('daily');
  const [hour, setHour] = useState(8);
  const [recipients, setRecipients] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setSchedules(await api.get<Schedule[]>('/api/report-schedules').catch(() => []));
  }
  useEffect(() => {
    void load();
  }, []);

  async function create() {
    if (!name.trim()) return;
    try {
      await api.post('/api/report-schedules', {
        name,
        objectType,
        frequency,
        hour,
        recipients: recipients.split(',').map((s) => s.trim()).filter(Boolean),
      });
      setName('');
      setRecipients('');
      await load();
    } catch {
      setError('Create failed (needs analytics.view).');
    }
  }

  async function remove(id: string) {
    await api.del(`/api/report-schedules/${id}`);
    await load();
  }

  return (
    <div className="card">
      <h1>Scheduled reports</h1>
      <p className="muted">Generated on a schedule and emailed (delivery needs SES). Daily/weekly for now.</p>
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}

      <table className="grid">
        <thead><tr><th>Name</th><th>Object</th><th>When</th><th>Next run</th><th></th></tr></thead>
        <tbody>
          {schedules.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.objectType}</td>
              <td>{s.frequency} @ {s.hour}:00</td>
              <td>{s.nextRunAt ? new Date(s.nextRunAt).toLocaleString() : '—'}</td>
              <td><button className="btn" onClick={() => void remove(s.id)}>Delete</button></td>
            </tr>
          ))}
          {schedules.length === 0 && <tr><td colSpan={5} className="empty">No scheduled reports.</td></tr>}
        </tbody>
      </table>

      <h2 style={{ fontSize: '1.05rem' }}>New schedule</h2>
      <div className="stack">
        <input placeholder="Report name" value={name} onChange={(e) => setName(e.target.value)} />
        <div className="row">
          <select value={objectType} onChange={(e) => setObjectType(e.target.value)}>
            {OBJECTS.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
          </select>
          <select value={frequency} onChange={(e) => setFrequency(e.target.value)}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
          </select>
          <input type="number" style={{ width: 80 }} value={hour} onChange={(e) => setHour(Number(e.target.value))} />
        </div>
        <input placeholder="Recipients (comma-separated emails)" value={recipients} onChange={(e) => setRecipients(e.target.value)} />
        <button className="btn btn-primary" onClick={() => void create()}>Create schedule</button>
      </div>
    </div>
  );
}
